// =========================================
// Guarantees — Swiper slider for the cards.
//   Desktop (>=1200): static 4-up (all cards fill the row, no drag).
//   Below 1200: auto-advancing draggable slider (1.15 peek, 2-up from 768).
// Re-inits across the breakpoint so autoplay only runs in slider mode.
// =========================================
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.block-guarantees__cards.swiper').forEach(function (el) {
        const mq = window.matchMedia('(min-width: 1200px)');
        let swiper = null;

        const build = function () {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }

            if (mq.matches) {
                // Desktop — static 4-up grid (nothing to drag).
                swiper = new Swiper(el, {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    allowTouchMove: false,
                });
            } else {
                // Mobile / tablet — auto-advancing draggable slider.
                swiper = new Swiper(el, {
                    modules: [Autoplay],
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    loop: true,
                    speed: 500,
                    grabCursor: true,
                    autoplay: { delay: 3500, disableOnInteraction: false },
                    breakpoints: {
                        768: { slidesPerView: 2 },
                    },
                });
            }
        };

        build();
        mq.addEventListener('change', build);
    });
});
